import inView from 'in-view';
import Timer from 'tick-tock';

export default class Stats {
  constructor(element) {
    this.element = element;
    this.ticking = false;
    this.complete = false;
    this.duration = 3000;
    this.iteration = 15;
    this.maxValue = this.getMaxValue();
    this.Timer = new Timer();
    this.update();
    this.listen();
    this.ready();
  }

  update() {
    // Check to see if stat is in view.
    if (inView.is(this.element)) {
      // Check to see if the count is in the process of counting or is complete.
      if (!this.complete && !this.Timer.active('counting')) {
        let step = 0;

        this.Timer.setInterval('counting', () => {
          step += this.iteration;

          if (step > this.duration) {
            // Stop the interval when the step is beyond the duration total.
            this.Timer.clear();
            // Marks the count complete.
            this.complete = true;
          } else {
            // Count up if there is more to go.
            this.count(step);
          }
        }, this.iteration);
      }
    } else {
      // Stat is out of view. Reset.
      this.complete = false;
    }

    this.ticking = false;
  }

  count(step) {
    let value = this.ease(step, 0, this.maxValue, this.duration);

    // Sanity check to make sure we don't go over the max
    // and don't go under zero.
    if (value >= this.maxValue) {
      value = this.maxValue;
    } else if (value <= 0) {
      value = 0;
    }

    this.setCurrentValue(Math.ceil(value));
  }

  change() {
    this.request();
  }

  request() {
    if (!this.ticking) {
      requestAnimationFrame(this.update.bind(this));
      this.ticking = true;
    }
  }

  ease(t, b, c, d) {
    // EaseOutCubic easing function.
    return c * ((t = t / d - 1) * t * t + 1) + b;
  }

  listen() {
    window.addEventListener('scroll', this.change.bind(this));
    window.addEventListener('resize', this.change.bind(this));
    window.addEventListener('orientationchange', this.change.bind(this));
  }

  ready() {
    return this.element.classList.add('ready');
  }

  setCurrentValue(value) {
    return this.element.innerText = value.toLocaleString();
  }

  getMaxValue() {
    return Number(this.element.getAttribute('data-value'));
  }
}
